import { useAuth0 } from '@auth0/auth0-react';

// Whether the signed-in user has a manage.rapnet permission: the "backoffice" permissions of the
// token, which the BFF checks on its side too.
export const useBackofficePermission = (permission: string) => {
  const { user } = useAuth0();
  const permissions: string[] | undefined = user?.['http://rapaport.com/permissions']?.backoffice;
  return !!permissions?.includes(permission);
};
